import React from 'react'
import KeyMonitor from './KeyMonitor'
import AnimationStage from './AnimationStage'
import ScrollMonitor from './ScrollMonitor'
import SideNavigation from './SideNavigation'
import SceneData from './SceneData'
import LoadProgressContainer from './LoadProgressContainer'
import StartButton from './StartButton'
import PortraitWarning from './PortraitWarning'
import InnerHeight from 'ios-inner-height'

class ScrollingSite extends React.Component{

  constructor(props){
    super(props)
    this.state = {
      scrollValue: 0,
      shouldNavDisplay: true,
      landscapeMode: false,
      hasStarted: false,
    }
    this.hasStarted = false
    this.sceneData = new SceneData().data
  }

  componentDidMount(){
    console.log()
    window.addEventListener("orientationchange", () => {	this.sizeElements()}, {capture: true});
    window.addEventListener('resize', () => { setTimeout(() => this.sizeElements(), 250) })
    this.sizeElements()
  }

  sizeElements(){
    const buttons = document.getElementById('button-holder')
    const height = window.innerWidth / 16 * 9
    if(height <= InnerHeight() ){
      if(buttons){
        buttons.style.height = height + "px"
      }
      this.setState({landscapeMode: false})
    } else {
      if(buttons){
        buttons.style.height = InnerHeight() + "px"
        buttons.style.width = (InnerHeight() / 9 * 16) + "px"
      }
      this.setState({landscapeMode: true})
    }
    this.hasStarted = false
  }

  debugChangeHandler(){
    const value = (this.state && this.state.debug) ? false : true
    this.setState({debug: value})
  }

  buildDebugger(){
    const style = {
      'position': 'fixed',
      'top': '0',
      'right': '0',
      'pointerEvents': 'null',
      'width': '200px',
    }
    if(this.state && this.state.debug){
      return(
        <div style={style}>
          <p>Frame Number: { Math.floor(this.state.scrollValue) }</p>
        </div>)
    } else {
      return(null)
    }
  }

  scrollChangeHandler(event){
    this.setState({
      scrollValue: event.scrollValue,
      scene: event.scene,
      playType: event.type,
      frameNumber: event.frameNumber,
      disableScrolling: event.disableScrolling,
    })
  }

  navigationClickHandler(event){
    const destination = event.currentTarget.getAttribute('data-destination')
    this.setState({ scrollValue: destination,
                    forceScroll: destination })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.forceScroll) {
      this.setState({ forceScroll: null });
    }
  }

  sceneLoadedHandler(scene){}

  loadCompleteHandler(){}

  loadChangeHandler(event){
    this.setState({loadProgress: event.loadProgress})
  }

  engagementHandler(){
    this.setState({hasStarted: true})
    setTimeout(() => {this.sizeElements()}, 250)
  }

  buildStartButton(){
    const buttonStyle =   {
      'position': 'absolute',
      'top': '50%',
      'left': '50%',
      'transform': 'translate(-50%,-50%)',
      'height': '57px',
      'width': '224px',
      'cursor': 'pointer',
      'border': 0,
    }
    if(!this.props.hasEngaged){
      return(
        <div>
          <a style={ buttonStyle }
            onClick={ (value) => this.engagementHandler() }>
            <StartButton/>
          </a>
          <PortraitWarning landscapeMode={this.state.landscapeMode}/>
        </div>
      )
    }
  }

  render(){
    const style = {
      'position': 'relative',
      'overflow': 'none',
      'maxHeight': '100%',
      'maxWidth': '100%',
    }
    const wrapperStyle = {
        'margin': '0 auto',
        'overflow': 'hidden',
    }
    if(!this.state.hasStarted){
      return(
        <div>
          {
            this.buildStartButton()
          }
        </div>
      )
    }
    this.hasStarted = true
    const shouldDisplay = this.state.scrollValue > this.sceneData.menuDisplayStartFrame
    return(
      <div>
      <div style={style}>
        <LoadProgressContainer
          data={this.sceneData.sceneNames}
          sceneLoadedHandler={this.sceneLoadedHandler.bind(this)}
          loadCompleteHandler={this.loadCompleteHandler.bind(this)}
          loadChangeHandler={this.loadChangeHandler.bind(this)}
        />
        <div style={wrapperStyle} id="wrapper">
          <ScrollMonitor
            scrollChangeHandler={this.scrollChangeHandler.bind(this)}
            sceneData={this.sceneData}
            scrollValue={this.state.forceScroll}
            loadProgress={this.state.loadProgress}
          />
          <AnimationStage
            scrollValue={this.state.scrollValue}
            data={this.sceneData}
            landscapeMode={this.state.landscapeMode}
            playType={this.state.playType}
          />
          <SideNavigation
            display={ shouldDisplay }
            sceneData={ this.sceneData }
            buttonClickHandler={ this.navigationClickHandler.bind(this)}
            landscapeMode={this.state.landscapeMode}
            loadProgress={this.state.loadProgress}
            scrollValue={this.state.scrollValue}
          />
          <KeyMonitor debugChangeHandler={this.debugChangeHandler.bind(this)}/>
        </div>
          {this.buildDebugger()}
      </div>
      <PortraitWarning landscapeMode={true}/>
      </div>
    )
  }
}


export default ScrollingSite



// WEBPACK FOOTER //
// ./src/ScrollingSite.js